import { Controller } from "@hotwired/stimulus"

/**
 * Simple tab switcher for admin forms.
 *
 * Usage:
 *   <div data-controller="tabs" data-tabs-active-class="border-primary text-foreground" data-tabs-inactive-class="border-transparent text-muted-foreground">
 *     <button data-tabs-target="tab" data-action="click->tabs#switch" data-tabs-panel="general">General</button>
 *     <div data-tabs-target="panel" data-tabs-name="general">...</div>
 *   </div>
 */
export default class extends Controller {
  static targets = ["tab", "panel"]
  static classes = ["active", "inactive"]
  static values = { default: { type: String, default: "" } }

  connect() {
    const defaultTab = this.defaultValue || this.tabTargets[0]?.dataset.tabsPanel
    if (defaultTab) this.show(defaultTab)
  }

  switch(event) {
    event.preventDefault()
    const name = event.currentTarget.dataset.tabsPanel
    if (name) this.show(name)
  }

  show(name) {
    // Update tabs
    this.tabTargets.forEach((tab) => {
      const isActive = tab.dataset.tabsPanel === name
      if (isActive) {
        tab.classList.add(...this.activeClasses)
        tab.classList.remove(...this.inactiveClasses)
      } else {
        tab.classList.remove(...this.activeClasses)
        tab.classList.add(...this.inactiveClasses)
      }
    })

    // Update panels
    this.panelTargets.forEach((panel) => {
      panel.classList.toggle("hidden", panel.dataset.tabsName !== name)
    })
  }
}
